import React from "react";
import "./FakeGallery.css";

export default function FakeGallery({
    images,
    onFinish,
}: {
    images: string[];
    onFinish: () => void;
}) {
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0,0,0,0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                    maxWidth: "600px",
                    height: "90%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <h3
                    style={{
                        fontSize: "1.8em",
                        color: "#333",
                        marginBottom: "15px",
                        textAlign: "left",
                    }}
                >
                    Trainingsdaten-Bibliothek
                </h3>
                <div
                    className="fake-gallery"
                    style={{ overflowY: "auto", overflowX: "hidden" }}
                >
                    {images.map((imgSrc) => (
                        <img className="fake-gallery-item" src={imgSrc}></img>
                    ))}
                    <div className="fake-gallery-item-text">
                        und viele viele <br></br> weitere Bilder...
                    </div>
                </div>
                <div className="fake-gallery-btn">
                    <button
                        onClick={onFinish}
                        style={{
                            fontSize: "1em",
                            padding: "15px 30px",
                            borderRadius: "12px",
                            border: "none",
                            backgroundColor: "#007bff",
                            color: "white",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                            transition: "background-color 0.3s ease",
                            outline: "none",
                            cursor: "pointer",
                        }}
                    >
                        Weiter
                    </button>
                </div>
            </div>
        </div>
    );
}
